export const replaceSpacesWithDashes = (str: string | undefined) => {
    return str?.replace(/\s+/g, '-');
};